export default class IPBoardArrows {
  amountArrowsRight?: number;
  amountArrowsLeft?: number;
  arrowsDesign?: string;
  arrowsLocation?: string;
}
